import * as React from "react";
import * as ReactDOM from "react-dom";
import { AuthContext } from "./context/AuthContext";
import AppPage from "./pages/AppPage";
import AuthStore from "./store/AuthStore";

function App() {
    const authStore = new AuthStore();
    return (
        <AuthContext.Provider
            value={{authStore}}
        >
            <AppPage />
        </AuthContext.Provider>

    );
}

ReactDOM.render(<App />, document.getElementById('app'));

